// extracted by mini-css-extract-plugin
export default {"select":"Select_select__7xuMN","error":"Select_error__ZdQX0"};